import { Component, OnInit, Output, EventEmitter, Inject, OnDestroy, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, DOCUMENT } from '@angular/common';
import { AuthenticationService } from '../../../core/services/auth.service';
import { environment } from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../../core/services/language.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, debounceTime, map, takeUntil } from 'rxjs';
import { changesLayout } from 'src/app/modals/layouts/layout.actions';
import { getLayoutMode } from 'src/app/modals/layouts/layout.selector';
import { RootReducerState } from 'src/app/modals';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SimplebarAngularModule } from 'simplebar-angular';
import { backToPortal, logout } from 'src/app/modals/Authentication/authentication.actions';
import { getUser } from 'src/app/modals/Authentication/authentication-selector';
import { User } from 'src/app/modals/Authentication/auth.models';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { EchoService } from 'src/app/core/services/echo.service';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TopSearchService } from 'src/app/modals/TopBar/top-search-service.service';
import { FormsModule } from '@angular/forms';
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  standalone:true,
  imports:[CommonModule,TranslateModule,BsDropdownModule,SimplebarAngularModule, RouterModule, FormsModule],
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit, OnDestroy {
  
  mode: any
  element: any;
  cookieValue: any;
  flagvalue: any;
  countryName: any;
  valueset: any;
  theme: any;
  layout: string;
  dataLayout$: Observable<string>;
  user$: Observable<any>;
  authObserver$: Observable<any>;
  userObj: User;
  // Define layoutMode as a property
  private destroy$ = new Subject<void>();

  constructor(@Inject(DOCUMENT) private document: any, private router: Router, private authService: AuthenticationService,
    public languageService: LanguageService,
    public translate: TranslateService,
    public _cookiesService: CookieService, 
    public store: Store<RootReducerState>,
    public localStorageService: LocalStorageService,
    public echoService: EchoService,
    private location: Location,
    private http: HttpClient,
    private searchService: TopSearchService,
  ) {}

  listLang: any = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Dutch', flag: 'assets/images/flags/germany.jpg', lang: 'nl' },
  ];

  openMobileMenu: boolean;

  //SEARCH ITEMS
  query = '';
  results: any[] = [];
  page = 1;
  loading = false;
  showResults = false;
  private queryChanged$ = new Subject<string>();

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();
  @ViewChild('searchWrapper') searchWrapper!: ElementRef;

  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: KeyboardEvent) {
    this.location.back();
  }
  
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    // Prevent error if ViewChild not initialized yet
    if (!this.searchWrapper) return;

    const clickedInside = this.searchWrapper.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.showResults = false;
    }
  }

  ngOnInit() {

    this.queryChanged$
      .pipe(debounceTime(500))
      .subscribe((value) => {
        this.page = 1;
        this.results = [];
        this.loadMore(); // or your search function
      });

    this.echoService.initEcho();
    this.userObj = this.localStorageService.getItem("currentUser");
    this.user$ = this.store.select(getUser);
    this.store.select(getUser)
            .pipe(takeUntil(this.destroy$))
            .subscribe((getUser) => {
              //Change made in user
              if(getUser){
                //User has been updated, It does not get triggered when the request fails
                // console.log("topbar lang set");
                this.languageService.checkAndSet(getUser.lang)
              }
              
              this.applySentryUser(getUser ?? this.userObj);
            });


    // this.initialAppState = initialState;
    this.store.select('layout').subscribe((data) => {
      this.theme = data.DATA_LAYOUT;
    })
    this.openMobileMenu = false;
    this.element = document.documentElement;

    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }
  }

  private applySentryUser(user: User | null): void {

    if (!user?.id) {
      Sentry.setUser(null);
      return;
    }

    Sentry.setUser({
      id: String(user.id),
      username: `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim() || undefined,
      email: user.email ?? undefined,
    });

    // Optional but very useful context
    Sentry.setContext('account', {
      lang: user.lang ?? null,
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.checkAndSet(lang);
  }

  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  logout() {
    this.store.dispatch(logout());
  }

  backToPortal(){
    this.store.dispatch(backToPortal());
  }

  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  changeLayout(layoutMode: string) {
    this.theme = layoutMode;
    this.store.dispatch(changesLayout({ layoutMode }));
    this.store.select(getLayoutMode).subscribe((layout) => {
      document.documentElement.setAttribute('data-layout', layout)
    })
  }


  onQueryChange(value: string) {
    this.loading = true;
    this.results = [];
    this.queryChanged$.next(value);
  }

  onScroll(event: any) {
    this.loading = true;
    const el = event.target;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50 && !this.loading) {
      this.loadMore();
    }
  }

  loadMore() {
    this.searchService.search(this.query, this.page).subscribe(data => {
      this.results = [...this.results, ...data];
      this.page++;
      this.loading = false;
    });
  }

  formatLabel(label: string): string {
    return label
      ? label
          .split(' | ')
          .map(part => part.trim())
          .filter(part => part !== '')
          .join(' | ')
      : '';
  }

  clearSearch(){
    this.query = "";
  }

}